import React from 'react';
import { toAbsoluteApiUrl } from '../../../../../helpers/http-client';

const roleClassMap = {
    ADMIN: 'bg-soft-danger text-danger',
    USER: 'bg-soft-primary text-primary',
    GUEST: 'bg-soft-secondary text-secondary',
};

const roleLabelMap = {
    ADMIN: 'Admin',
    USER: 'Usuario',
    GUEST: 'Invitado',
};

const getInitials = (name = '') => {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
        return 'U';
    }

    return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');
};

export const SearchResultUser = ({ item, onSelect }) => {
    const role = String(item?.role || '').toUpperCase();
    const photoUrl = toAbsoluteApiUrl(item?.photoUrl || '');

    return (
        <button
            type="button"
            className="search-result-row"
            onClick={() => onSelect?.(item)}
        >
            <div className="d-flex align-items-center gap-3 w-100">
                {photoUrl ? (
                    <img className="search-result-user__avatar" src={photoUrl} alt={item?.name || 'Usuario'} />
                ) : (
                    <div className="search-result-user__avatar search-result-user__avatar--fallback">
                        {getInitials(item?.name)}
                    </div>
                )}

                <div className="min-w-0 flex-grow-1">
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                        <div className="search-result-row__title mb-0">{item?.name || 'Sin nombre'}</div>
                        <span className={`badge ${roleClassMap[role] || 'bg-soft-secondary text-secondary'}`}>
                            {roleLabelMap[role] || role || 'Sin rol'}
                        </span>
                    </div>
                    <div className="search-result-row__meta">{item?.email || 'Sin correo'}</div>
                </div>
            </div>
        </button>
    );
};
